import confetti from "canvas-confetti"
import { useEffect } from "react"

const palette = {
  blue600: "#2563ea",
  blue400: "#5995f9",
  teal600: "#178774",
  teal300: "#54c5a5",
  red600: "#d53e38",
  red400: "#f38684",
  yellow600: "#f1a324",
  yellow300: "#ffe087",
}

const CONFETTI_COLORS = [
  palette.blue600,
  palette.blue600,
  palette.teal600,
  palette.red600,
  palette.yellow600,
  palette.blue400,
  palette.teal300,
  palette.red400,
  palette.yellow300,
]

const EMIT_DURATION_MS = 3000

let streamer

const shapes = () => {
  if (!streamer) {
    streamer = confetti.shapeFromPath({
      path: "M0 0h2v5H0z",
      matrix: [2, 0, 0, 2, -2, -5],
    })
  }
  return ["square", "circle", streamer]
}

const storageKey = (key) => `confettiShown:${key}`

const alreadyShown = (key) => {
  try {
    return sessionStorage.getItem(storageKey(key)) === "true"
  } catch (error) {
    return false
  }
}

const markShown = (key) => {
  try {
    sessionStorage.setItem(storageKey(key), "true")
  } catch (error) {
    // Storage can be unavailable (private mode); the rain still plays once per load.
  }
}

const reducedMotion = () =>
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false

const pickColor = () =>
  CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)]

// canvas-confetti colours particles by index within one call, so a small
// particleCount would only ever reach the first entries of the palette.
const emit = ({ particleCount, ...overrides }) =>
  confetti({
    particleCount,
    angle: 270,
    spread: 45,
    startVelocity: 12,
    gravity: 0.6,
    drift: (Math.random() - 0.5) * 0.6,
    ticks: 500,
    colors: Array.from({ length: particleCount }, pickColor),
    origin: { x: Math.random(), y: -0.05 },
    ...overrides,
  })

const rainFromTheTop = () => {
  const stopAt = Date.now() + EMIT_DURATION_MS
  let cancelled = false

  const frame = () => {
    if (cancelled) return

    emit({ particleCount: 2, scalar: 0.9, shapes: shapes() })

    if (Date.now() < stopAt) requestAnimationFrame(frame)
  }

  frame()

  return () => {
    cancelled = true
  }
}

export const useConfettiOnce = (key, enabled = true) => {
  useEffect(() => {
    if (!enabled || !key || reducedMotion() || alreadyShown(key))
      return undefined

    markShown(key)
    return rainFromTheTop()
  }, [key, enabled])
}
